import { render } from "./tracking-task-footer.vue?vue&type=template&id=0a795997&scoped=true"
import script from "./tracking-task-footer.vue?vue&type=script&lang=js"
export * from "./tracking-task-footer.vue?vue&type=script&lang=js"

import "./tracking-task-footer.vue?vue&type=style&index=0&id=0a795997&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a795997"]])

export default __exports__